import React from 'react';
import { Empty } from 'antd';

interface NoRecordFoundInterfaceProps {
    children?: React.ReactElement;
    message?: string;
}

const NoRecordFound: React.FC<NoRecordFoundInterfaceProps> = ({ children, ...props }): React.ReactElement => {
    const { message } = props;
    return (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} className="p-5" description={message || 'No record found.'}>
            {children}
        </Empty>
    );
};

export default NoRecordFound;
